import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * AdminRoute - Guards routes that require admin privileges.
 * Shows a loading spinner while auth state is being resolved.
 * Redirects unauthenticated users to login and non-admin users to the dashboard.
 *
 * @param {React.ReactNode} children - The admin-only content to render.
 */
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  /* Show loading spinner while authentication state is being determined. */
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
      </div>
    );
  }

  /* Redirect to login if user is not authenticated. */
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  /* Redirect non-admin users to the dashboard. */
  if (!user.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
